import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CartItemFilterPipe } from './cart-item-filter.pipe';

@NgModule({
    declarations: [
        CartItemFilterPipe
    ],
    exports: [
        CartItemFilterPipe
    ],
    imports: [
        CommonModule,
        FormsModule
    ]
})
export class CartItemFilterModule {
}



// WEBPACK FOOTER //
// ./src/app/_pipes/cart-item-filter.module.ts